export const baseUrl = 'http://192.248.151.65:3400';
